import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { ShieldCheck, Search, BarChart3, Receipt, Compass, Leaf } from "lucide-react";

const SERVICES = [
    {
        icon: Search,
        title: "Freight cost diagnostic",
        body: "We audit 90 days of freight invoices, surcharges and lane spend. You get a written report showing exactly where money is leaking and how much is recoverable.",
    },
    {
        icon: Compass,
        title: "Procurement advisory",
        body: "From RFP design to carrier scoring and contract negotiation, we sit on your side of the table — independent of forwarders and freight lines.",
    },
    {
        icon: BarChart3,
        title: "Shipment visibility setup",
        body: "Forwarder-agnostic tracking, exception alerts and a single dashboard across every leg of every shipment — wired into your existing operations.",
    },
    {
        icon: Receipt,
        title: "Invoice & cost audit",
        body: "Every charge tied back to the original quote. Catch discrepancies before payment, recover overcharges, and build a clean cost-of-goods picture.",
    },
    {
        icon: ShieldCheck,
        title: "Customs orchestration",
        body: "We coordinate with licensed AU customs brokers, manage documentation, compliance checks and clearance status — inside the same shipment workflow.",
    },
    {
        icon: Leaf,
        title: "Scope-3 emissions reporting",
        body: "Container-level carbon measurement using verified data sources. Defensible numbers for your annual sustainability report and CBAM disclosures.",
    },
];

export default function Services() {
    return (
        <div data-testid="services-page" className="bg-[#0A0A0E] text-zinc-100 min-h-screen">
            <Navbar />
            <main className="pt-28 pb-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mb-14">
                    <span className="section-tag">Services</span>
                    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mt-5 leading-[0.95] tracking-tighter">
                        Six ways we plug the gaps in your freight.
                    </h1>
                    <p className="text-zinc-400 mt-6 leading-relaxed text-lg">
                        Engage us on one or all. Each service is designed to stand alone and
                        compound when stacked.
                    </p>
                </div>

                <div className="grid lg:grid-cols-3 gap-4">
                    {SERVICES.map((s, i) => (
                        <article
                            key={s.title}
                            data-testid={`service-card-${i}`}
                            className="card-glow rounded-2xl p-7 lg:p-8 flex flex-col"
                        >
                            <div
                                className="w-11 h-11 rounded-lg flex items-center justify-center mb-6"
                                style={{
                                    background: "rgba(0,240,255,0.08)",
                                    border: "1px solid rgba(0,240,255,0.25)",
                                }}
                            >
                                <s.icon size={18} className="text-cyan-300" />
                            </div>
                            <h3 className="font-display text-xl text-white tracking-tight">{s.title}</h3>
                            <p className="text-sm text-zinc-400 mt-3 leading-relaxed flex-1">{s.body}</p>
                        </article>
                    ))}
                </div>

                <div className="mt-16 card-glow rounded-2xl p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
                    <div>
                        <div className="eyebrow">Ready to start?</div>
                        <h3 className="font-display text-2xl sm:text-3xl text-white mt-2">
                            Get a 30-min freight diagnostic — free for early-access members.
                        </h3>
                    </div>
                    <Link to="/quote" className="btn-primary" data-testid="services-cta">
                        Request a quote
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}
